import { Feature } from "ol";
import { all, config } from "./config";
import { filterByText } from "./search";

export interface IFilters {
    [name: string]: string | (number | string)[];
}

export const filterFeatures = (allFeatures: Feature[], filterOptions: IFilters): Feature[] => {
    let filteredFeatures = allFeatures;
    filterOptions &&
        Object.keys(filterOptions).map((name: string) => {
            const value = filterOptions[name];
            if (value === all) {
                return;
            }
            const isMultipleSelection = config.sideView.filters.find(
                (conf) => conf.field === name && conf.multipleSelection
            );

            if (name === config.sideView.textFilter.field) {
                filteredFeatures = filterByText(filteredFeatures, value.toString());
            } else if (typeof value === "string") {
                filteredFeatures = filteredFeatures.filter(
                    (f) => (f.get(name) !== null || f.get(name) !== undefined) && f.get(name)?.toString() === value
                );
            } else if (typeof value === "number") {
                filteredFeatures = filteredFeatures.filter(
                    (f) => (f.get(name) !== null || f.get(name) !== undefined) && f.get(name) === value
                );
            } else if (isMultipleSelection) {
                filteredFeatures = filteredFeatures.filter((f) => {
                    const hasKey = f.getKeys().includes(name);
                    const featureValue = hasKey && f.get(name);
                    return featureValue && value.includes(featureValue);
                });
            } else {
                filteredFeatures = filteredFeatures.filter((f) => {
                    const featureValue = f.get(name);
                    return featureValue >= value[0] && (value[1] === 0 ? true : featureValue <= value[1]);
                });
            }
        });

    return filteredFeatures;
};

export const filterByExtent = (features: Feature[], extent: number[]): Feature[] => {
    if (!features) {
        return [];
    }
    const [xmin, ymin, xmax, ymax] = extent;
    return (features = features.filter((feature) => {
        const [fxmin, fymin, fxmax, fymax] = feature.getGeometry().getExtent();
        return !(fxmin >= xmax || fxmax <= xmin || fymin >= ymax || fymax <= ymin);
    }));
};
